import {useState} from 'react';
import postAddInstanceStep from '../functions/API/postAddInstanceStep.js'
import { toast } from '../lib/toast.js';

export default function AddInstanceStepForm({instanceId, insertAfterPosition, setVisible, onStepAdded}) {
    const [formData, setFormData] = useState({
        name: "",
        actor_type: "tenant",
    });

    async function handleSubmit() {
        if (!formData.name) {
            toast.error('Step name is required.');
            return;
        }

        const body = {
            task_instance_id: instanceId,
            name: formData.name,
            actor_type: formData.actor_type,
            insert_after_position: insertAfterPosition,
        };

        const response = await postAddInstanceStep(body);
        if (response.response.ok) {
            toast.success('Step added successfully.');
            setVisible(false);
            if (onStepAdded) onStepAdded();
        } else {
            toast.error('Failed to add step.');
        }
    }

    function handleChange(event) {
        let name = event.target.name;
        let value = event.target.value;
        setFormData({...formData, [name]: value});
    }

    return (
        <form>
            <div className="space-y-8">
                <div>
                    <h2 className="text-base font-semibold leading-7 text-gray-900">
                        Add Step
                    </h2>
                    <p className="mt-1 text-sm leading-6 text-gray-600">Add an ad-hoc step to this instance</p>
                </div>

                <div className="grid max-w-2xl grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 md:col-span-1">
                    <div className="sm:col-span-3">
                        <label htmlFor="name" className="block text-sm font-medium leading-6 text-gray-900">
                            Name
                        </label>
                        <div className="mt-2">
                            <input
                                required
                                type="text"
                                onChange={handleChange}
                                value={formData.name}
                                name="name"
                                id="name"
                                className="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                            />
                        </div>
                    </div>

                    <div className="sm:col-span-3">
                        <label htmlFor="actor_type" className="block text-sm font-medium leading-6 text-gray-900">
                            Actor
                        </label>
                        <div className="mt-2">
                            <select
                                onChange={handleChange}
                                name="actor_type"
                                id="actor_type"
                                value={formData.actor_type}
                                className="pl-2 block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-blue-700 sm:text-sm sm:leading-6"
                            >
                                <option value="tenant">Tenant</option>
                                <option value="admin">Admin</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>

            <div className="mt-6 flex items-center justify-start gap-x-6">
                <button
                    type="button"
                    onClick={handleSubmit}
                    className="rounded-md bg-blue-700 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-blue-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700"
                >
                    Add Step
                </button>
                <button type="button" onClick={() => setVisible(false)} className="text-sm font-semibold leading-6 text-gray-900">
                    Cancel
                </button>
            </div>
        </form>
    );
}
